import { type Department, tr } from "../../engine";
import { L1 } from "./l1-labor";
import { L2 } from "./l2-er";
import { OPD } from "./l3-opd";
import { PPH } from "./l4-pph";
import { ORL } from "./l5-or";

export const OBGYN: Department = {
  id: "obgyn",
  name: tr("婦產科", "OB/GYN"),
  tagline: tr("五個關卡，同一群人，同一個月", "Five levels, one cast, one month"),
  attending: "vs",
  attendingDialog: "vs",
  grader: tr("婦產科主治醫師", "an OB/GYN attending"),
  note: tr(
    "建議照順序玩：第一關是教學關；第二關的病人會在第五關開刀；第三關的病人會在第四關生產。",
    "Best played in order: Level 1 is the tutorial; the patient from Level 2 has her surgery in Level 5; the patient from Level 3 delivers in Level 4.",
  ),
  levels: [L1, L2, OPD, PPH, ORL],
};
